
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-listing/category",
      function () {
        return require("private-next-pages/add-listing/category.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-listing/category"])
      });
    }
  